var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAddBot({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4C10.3431 4 9 5.34315 9 7C9 8.65685 10.3431 10 12 10C13.6569 10 15 8.65685 15 7C15 5.34315 13.6569 4 12 4ZM7 7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7C17 9.76142 14.7614 12 12 12C9.23858 12 7 9.76142 7 7ZM9.92597 14.2049C10.1345 14.7163 9.889 15.2999 9.3776 15.5084C7.06131 16.453 5.5 18.5813 5.5 20.9999C5.5 21.5522 5.05228 21.9999 4.5 21.9999C3.94772 21.9999 3.5 21.5522 3.5 20.9999C3.5 17.6777 5.641 14.8723 8.6224 13.6565C9.1338 13.448 9.71743 13.6935 9.92597 14.2049Z",
    fill: "#10A37F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2687 18.5124L20.9041 19.2182C20.6155 19.3043 20.4712 19.3474 20.3531 19.4329C20.2486 19.5085 20.1594 19.6079 20.0913 19.7247C20.0143 19.8565 19.9749 20.018 19.8963 20.3409L19.252 22.9875L18.6241 20.337C18.5475 20.0135 18.5092 19.8518 18.433 19.7195C18.3656 19.6024 18.277 19.5024 18.173 19.4261C18.0554 19.3399 17.9114 19.2959 17.6234 19.208L15.2632 18.4875L17.6278 17.7817C17.9164 17.6956 18.0607 17.6526 18.1788 17.5671C18.2833 17.4914 18.3725 17.392 18.4407 17.2753C18.5177 17.1434 18.557 16.982 18.6356 16.659L19.2799 14.0124L19.9078 16.663C19.9844 16.9864 20.0227 17.1481 20.0989 17.2805C20.1663 17.3976 20.2549 17.4975 20.3589 17.5738C20.4765 17.6601 20.6205 17.7041 20.9085 17.792L23.2687 18.5124Z",
    stroke: "#10A37F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddBot);
export default __webpack_public_path__ + "static/media/icon-add-bot.d8d27cff6fc2ed6be623eff10db3b0ea.svg";
export { ForwardRef as ReactComponent };